<template>
  <div class="grocery-components">
    <MyModal @close="closeModal" v-if="modal">
      <!-- default スロットコンテンツ -->
      <div class="iframe-wrapper">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/41o9jw8NbLQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <!-- /default -->
    </MyModal>
    <div class="grocery">
      <div class="head-wrapper">
        <div class="jumbotron">
          <img src="../../assets/img/job/grocery/jumbotron.jpg" alt="" class="over_display">
          <img src="../../assets/img/job/grocery/jumbotron_under.jpg" alt="" class="under_display">
        </div>
        <div class="message-tile">
          <div class="message-tile-inner">
            <div class="message">
              <img src="../../assets/img/job/grocery/catch.png" alt="店舗の中心で、棚をカラフルに彩る。人と世の中に敏感です。" width="390px">
            </div>
            <div class="movie-button" @click="openModal">
              <img src="../../assets/img/job/movie_button.png" alt="1分で仕事を見る" width="360px">
            </div>
          </div>
        </div>
      </div>
      <div class="main-contents">
        <div class="type-section">
          <FukidashiTitle title="どんなタイプの先輩がいる？" />
          <TypeAnswer genre="grocery" message="会話好きで、世の中の<br>トレンドに敏感でいたい人。"/>
        </div>
        <div class="type-section">
          <FukidashiTitle title="1日でお客様と接する時間は？" />
          <Graph graphNumber="85" />
          <div class="details">
            <p>
            グロサリー部は、店舗全体の売上のおよそ4割を担う部門。お菓子／調味料／パン／飲料／お酒…。担当する商品は幅広く、１日の8割程度は売場にいます。お客様とお話しする機会はとにかく多く、他の売場にご案内することもよくあります。
            </p>
            <p>
            祝祭日などお客様が増える日には、店頭や通路脇のスペースに特設売場を設けます。特設売場は、お正月、バレンタインデー、受験シーズン、お盆、運動会シーズン、クリスマスなどのタイミングに季節商品をアピールする場にもなります。
            </p>
            <p>
            たとえばドレッシングをはじめ、お客様が「こんなものまであるの！」と驚く種類を揃えるのがsanwaのこだわり。世の中のトレンドに対する興味や、アンテナを張ることは大切です。お客様との対話では暖かい気持ちでコミュニケーションを取り、売場づくりでは冷静な思考や判断力を発揮する。そんな二面性がおもしろいと思っています。
            </p>
          </div>
        </div>
        <ScheduleLink />
      </div>
    </div>
  </div>
</template>

<script>
import MyModal from '@/components/MyModal.vue'
import FukidashiTitle from '@/components/job/FukidashiTitle.vue'
import TypeAnswer from '@/components/job/TypeAnswer.vue'
import Graph from '@/components/job/Graph.vue'
import ScheduleLink from '@/components/job/ScheduleLink.vue'
export default {
  name: 'Grocery',
  components: {
    MyModal,
    FukidashiTitle,
    TypeAnswer,
    Graph,
    ScheduleLink
  },
  data() {
    return {
      modal: false,
    }
  },
  methods: {
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false
    },
  }
}
</script>
<style scoped lang="scss">
.iframe-wrapper{
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 56%;
  iframe{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.grocery {
  padding-bottom: 100px;
  margin: 0 auto;
  &:before {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    left: 0;
    top: 800px;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
  &:after {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    right: 0;
    top: 0;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
}
.head-wrapper {
  position: relative;
}
.jumbotron {
  margin: 0 auto;
  max-width: 1300px;
  width: 100%;
}
.message-tile {
  position: absolute;
  display: flex;
  top: 0;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  transform: translateX(-25%);
  @media print, screen and (max-width: 960px) {
    transform: translateX(0);
    width: 50%;
  }
}
.message-tile-inner {
  position: relative;
}
.movie-button {
  position: absolute;
  bottom: 30px;
  right: -30px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  @media print, screen and (max-width: 960px) {
    right: -5px;
  }
  &:hover {
    opacity: 0.5;
  }
  img {
    vertical-align: middle;
  }
}
.main-contents {
  margin: 0 auto;
  margin-top: 100px;
  max-width: 750px;
  width: 100%;
  @media print, screen and (max-width: 750px) {
    width: 90%;
  }
}
.type-section + .type-section {
  margin-top: 100px;
}
.details {
  font-size: 12px;
  line-height: 2em;
  margin-top: 50px;
}
</style>
